import React from 'react';

import PropTypes from 'prop-types';

import theme, { StylableComponent } from '@adsk/alloy-react-theme';

type Props = StylableComponent<HTMLDivElement> & {
  disableBorder?: boolean;
};

const Footer = ({
  style,
  className,
  children,
  disableBorder,
  ...props
}: Props) => (
  <div
    {...props}
    className={className}
    css={[
      {
        display: 'flex',
        justifyContent: 'flex-end',
        borderTop: !disableBorder
          ? `1px solid ${theme.tokens.colors.border.subtle.value}`
          : '',
        padding: `${theme.spacing.M}px ${theme.spacing.L}px`,
      },
      style,
    ]}
  >
    {children}
  </div>
);

Footer.propTypes = {
  /** The content of modal */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string,
  /** disable border top */
  disableBorder: PropTypes.bool,
};

export default Footer;
